import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useTheme as useCustomTheme } from '../contexts/ThemeContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Divider,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  InputAdornment,
} from '@mui/material';
import {
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  AttachMoney as AttachMoneyIcon,
  Telegram as TelegramIcon,
  WhatsApp as WhatsAppIcon,
  Instagram as InstagramIcon,
  Web as WebIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Settings as SettingsIcon,
  Payment as PaymentIcon,
  Description as DescriptionIcon,
  TrendingUp as TrendingUpIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  ExpandMore as ExpandMoreIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  Assessment as AssessmentIcon,
  Memory as MemoryIcon,
  Code as CodeIcon,
  Security as SecurityIcon,
  Domain as DomainIcon,
  Api as ApiIcon,
  Chat as ChatIcon,
  Campaign as CampaignIcon,
  Analytics as AnalyticsIcon,
  Notifications as NotificationsIcon,
  History as HistoryIcon,
  Folder as FolderIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Flag as FlagIcon,
  FlagOutlined as FlagOutlinedIcon,
  AccessTime as AccessTimeIcon,
  CalendarToday as CalendarIcon,
  AccountBalance as AccountBalanceIcon,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon,
  Assignment as AssignmentIcon,
  ViewKanban as ViewKanbanIcon,
  Timeline as TimelineIcon,
  Speed as SpeedIcon,
  Storage as StorageIcon,
  DataUsage as DataUsageIcon,
  NetworkCheck as NetworkCheckIcon,
  VpnKey as VpnKeyIcon,
  Webhook as WebhookIcon,
  IntegrationInstructions as IntegrationIcon,
  Psychology as PsychologyIcon,
  SmartToy as SmartToyIcon,
  AutoAwesome as AutoAwesomeIcon,
  Tune as TuneIcon,
  Palette as PaletteIcon,
  Language as LanguageIcon,
  Translate as TranslateIcon,
  ContentCopy as ContentCopyIcon,
  Share as ShareIcon,
  Link as LinkIcon,
  OpenInNew as OpenInNewIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  VisibilityOff as VisibilityOffIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  AddCircle as AddCircleIcon,
  RemoveCircle as RemoveCircleIcon,
  PlayArrow as PlayIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  RestartAlt as RestartIcon,
  PowerSettingsNew as PowerIcon,
  PowerOff as PowerOffIcon,
  Sync as SyncIcon,
  SyncProblem as SyncProblemIcon,
  Error as ErrorIcon,
  ErrorOutline as ErrorOutlineIcon,
  Info as InfoIcon,
  InfoOutlined as InfoOutlinedIcon,
  Help as HelpIcon,
  HelpOutline as HelpOutlineIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Support as SupportIcon,
  ContactSupport as ContactSupportIcon,
  Feedback as FeedbackIcon,
  RateReview as RateReviewIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  Bookmark as BookmarkIcon,
  BookmarkBorder as BookmarkBorderIcon,
  Report as ReportIcon,
  ReportProblem as ReportProblemIcon,
  BugReport as BugReportIcon,
  Build as BuildIcon,
  Construction as ConstructionIcon,
  Engineering as EngineeringIcon,
  Science as ScienceIcon,
  Biotech as BiotechIcon,
} from '@mui/icons-material';
import axios from '../config/axios';
import { API_CONFIG } from '../config/api';

// Interfaces
interface Client {
  id: string;
  company_name: string;
  contact_name: string;
  email: string;
  phone?: string;
  cnpj?: string;
  cpf?: string;
  status: 'active' | 'inactive' | 'suspended' | 'trial';
  plan_type: 'com_api' | 'sem_api';
  created_at: string;
  updated_at: string;
  notes?: string;
  avatar_url?: string;
  custom_fields: Record<string, any>;
  tags: string[];
  client_contracts?: Contract[];
  client_payments?: Payment[];
  client_crm_configs?: CRMConfig;
  client_ai_prompts?: AIPrompt[];
}

interface Contract {
  id: string;
  contract_number: string;
  start_date: string;
  end_date?: string;
  monthly_value: number;
  payment_day: number;
  status: 'active' | 'suspended' | 'cancelled' | 'expired';
  contract_type: 'monthly' | 'quarterly' | 'yearly' | 'custom';
  auto_renewal: boolean;
  created_at: string;
  updated_at: string;
  contract_terms?: string;
  special_conditions?: string;
}

interface Payment {
  id: string;
  contract_id?: string;
  amount: number;
  due_date: string;
  paid_date?: string;
  payment_method?: string;
  status: 'pending' | 'paid' | 'overdue' | 'cancelled' | 'refunded';
  transaction_id?: string;
  payment_gateway?: string;
  created_at: string;
  updated_at: string;
  notes?: string;
  late_fee: number;
  discount: number;
}

interface CRMConfig {
  id: string;
  frontend_url?: string;
  backend_url?: string;
  api_key?: string;
  webhook_url?: string;
  whatsapp_instance_id?: string;
  telegram_bot_token?: string;
  instagram_config: Record<string, any>;
  custom_domain?: string;
  ssl_enabled: boolean;
  created_at: string;
  updated_at: string;
}

interface AIPrompt {
  id: string;
  prompt_type: 'whatsapp' | 'telegram' | 'instagram' | 'webchat' | 'email' | 'general';
  prompt_name: string;
  prompt_content: string;
  version: string;
  is_active: boolean;
  variables: Record<string, any>;
  created_at: string;
  updated_at: string;
}

interface DashboardStats {
  total_clients: number;
  active_clients: number;
  total_revenue: number;
  pending_payments: number;
  overdue_payments: number;
}

// Componente principal
const ClientManagement: React.FC = () => {
  const { mode } = useCustomTheme();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  // Estados principais
  const [clients, setClients] = useState<Client[]>([]);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // Estados de filtros e busca
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dense, setDense] = useState(false);
  
  // Estados de diálogos
  const [clientDialogOpen, setClientDialogOpen] = useState(false);
  const [contractDialogOpen, setContractDialogOpen] = useState(false);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [crmConfigDialogOpen, setCrmConfigDialogOpen] = useState(false);
  const [promptDialogOpen, setPromptDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [clientIdToDelete, setClientIdToDelete] = useState<string | null>(null);
  
  // Estados de formulários
  const [clientForm, setClientForm] = useState<Partial<Client>>({});
  const [contractForm, setContractForm] = useState<Partial<Contract>>({});
  const [paymentForm, setPaymentForm] = useState<Partial<Payment>>({});
  const [crmConfigForm, setCrmConfigForm] = useState<Partial<CRMConfig>>({});
  const [promptForm, setPromptForm] = useState<Partial<AIPrompt>>({});
  
  // Estados para edição
  const [selectedPaymentId, setSelectedPaymentId] = useState<string | null>(null);
  const [selectedContractId, setSelectedContractId] = useState<string | null>(null);
  
  // Estados de abas
  const [activeTab, setActiveTab] = useState(0);
  const [clientDetailTab, setClientDetailTab] = useState(0);
  const [clientTasks, setClientTasks] = useState<any[]>([]);
  const [loadingTasks, setLoadingTasks] = useState(false);

  // Estilos locais com acento roxo
  const purple = {
    main: '#7c3aed',
    light: '#8b5cf6',
    dark: '#6d28d9',
    softBg: 'rgba(124, 58, 237, 0.12)'
  };

  const styles = {
    buttonPrimary: {
      background: `linear-gradient(90deg, ${purple.dark}, ${purple.main})`,
      color: '#ffffff',
      boxShadow: '0 6px 14px rgba(124, 58, 237, 0.35)',
      '&:hover': {
        background: `linear-gradient(90deg, ${purple.main}, ${purple.light})`,
        boxShadow: '0 8px 18px rgba(124, 58, 237, 0.45)',
        color: '#ffffff',
      }
    },
    card: {
      p: 2,
      borderRadius: 3,
      border: '1px solid rgba(124, 58, 237, 0.12)',
      boxShadow: '0 10px 30px rgba(2, 6, 23, 0.15)'
    },
    iconAccent: {
      color: purple.main
    },
    numberAccent: {
      color: purple.main,
      fontWeight: 700
    },
    tabs: {
      '& .MuiTabs-indicator': {
        height: 3,
        backgroundColor: purple.main,
        borderRadius: 3
      },
      '& .MuiTab-root.Mui-selected': {
        color: purple.main,
        fontWeight: 600
      }
    },
    table: {
      head: {
        '& .MuiTableCell-head': {
          backgroundColor: 'rgba(124, 58, 237, 0.06)',
          fontWeight: 600
        }
      },
      row: {
        '&:hover': {
          backgroundColor: 'rgba(124, 58, 237, 0.04)'
        }
      }
    },
    topActions: {
      display: 'flex',
      gap: 1,
      '& .MuiButton-root': {
        backgroundColor: purple.softBg,
        color: purple.main,
        border: `1px solid ${purple.main}22`,
        '&:hover': {
          backgroundColor: `${purple.main}1f`,
          transform: 'translateY(-1px)'
        }
      }
    }
  } as const;
  
  // Estados de menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);
  
  // Estados de dashboard
  const [dashboardStats, setDashboardStats] = useState<DashboardStats | null>(null);

  // Carregar dados iniciais
  useEffect(() => {
    loadClients();
    loadDashboardStats();
  }, [currentPage, searchQuery, statusFilter, planFilter]);

  // Funções de carregamento de dados
  const loadClients = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: currentPage.toString(),
        limit: '20',
        ...(searchQuery && { search: searchQuery }),
        ...(statusFilter && { status: statusFilter }),
        ...(planFilter && { plan_type: planFilter }),
      });

      const response = await axios.get(`${API_CONFIG.BASE_URL}/clients?${params}`);
      
      if (response.data.success) {
        setClients(response.data.data);
        setTotalPages(response.data.pagination.pages);
      } else {
        setError('Erro ao carregar clientes');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao carregar clientes');
    } finally {
      setLoading(false);
    }
  };

  const loadDashboardStats = async () => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/clients/dashboard/overview`);
      
      if (response.data.success) {
        setDashboardStats(response.data.data);
      }
    } catch (err: any) {
      console.error('Erro ao carregar estatísticas:', err);
    }
  };

  const loadClientDetails = async (clientId: string) => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/clients/${clientId}`);
      
      if (response.data.success) {
        setSelectedClient(response.data.data);
        // Carregar tarefas do cliente
        loadClientTasks(clientId);
      }
    } catch (err: any) {
      setError('Erro ao carregar detalhes do cliente');
    }
  };

  const loadClientTasks = async (clientId: string) => {
    try {
      setLoadingTasks(true);
      const response = await axios.get(`${API_CONFIG.BASE_URL}/kanban/cards/client/${clientId}`);
      
      if (response.data.success) {
        setClientTasks(response.data.data || []);
      }
    } catch (err: any) {
      console.error('Erro ao carregar tarefas do cliente:', err);
      setClientTasks([]);
    } finally {
      setLoadingTasks(false);
    }
  };

  // Funções de manipulação de clientes
  const handleCreateClient = async () => {
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/clients`, clientForm);
      
      if (response.data.success) {
        setSuccess('Cliente criado com sucesso!');
        setClientDialogOpen(false);
        setClientForm({});
        loadClients();
      } else {
        setError('Erro ao criar cliente');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao criar cliente');
    }
  };

  const handleUpdateClient = async () => {
    if (!selectedClient) return;
    
    try {
      const response = await axios.put(`${API_CONFIG.BASE_URL}/clients/${selectedClient.id}`, clientForm);
      
      if (response.data.success) {
        setSuccess('Cliente atualizado com sucesso!');
        setClientDialogOpen(false);
        setClientForm({});
        loadClients();
        loadClientDetails(selectedClient.id);
      } else {
        setError('Erro ao atualizar cliente');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao atualizar cliente');
    }
  };

  const handleDeleteClient = async () => {
    const idToDelete = clientIdToDelete ?? selectedClientId;
    if (!idToDelete) return;
    
    try {
      const response = await axios.delete(`${API_CONFIG.BASE_URL}/clients/${idToDelete}`);
      
      if (response.data.success) {
        setSuccess('Cliente deletado com sucesso!');
        setDeleteDialogOpen(false);
        setClientIdToDelete(null);
        setSelectedClientId(null);
        if (selectedClient?.id === idToDelete) setSelectedClient(null);
        loadClients();
      } else {
        setError('Erro ao deletar cliente');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao deletar cliente');
    }
  };

  // Funções de manipulação de contratos
  const handleCreateContract = async () => {
    if (!selectedClient) return;
    
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/clients/${selectedClient.id}/contracts`, contractForm);
      
      if (response.data.success) {
        setSuccess('Contrato criado com sucesso!');
        setContractDialogOpen(false);
        setContractForm({});
        loadClientDetails(selectedClient.id);
      } else {
        setError('Erro ao criar contrato');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao criar contrato');
    }
  };

  // Funções de manipulação de pagamentos
  const handleCreatePayment = async () => {
    if (!selectedClient) return;
    
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/clients/${selectedClient.id}/payments`, paymentForm);
      
      if (response.data.success) {
        setSuccess('Pagamento criado com sucesso!');
        setPaymentDialogOpen(false);
        setPaymentForm({});
        loadClientDetails(selectedClient.id);
      } else {
        setError('Erro ao criar pagamento');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao criar pagamento');
    }
  };

  const handleMarkPaymentAsPaid = async (paymentId: string) => {
    try {
      const response = await axios.put(`${API_CONFIG.BASE_URL}/clients/payments/${paymentId}/mark-paid`, {
        paid_date: new Date().toISOString().split('T')[0],
        payment_method: 'pix'
      });
      
      if (response.data.success) {
        setSuccess('Pagamento marcado como pago!');
        if (selectedClient) {
          loadClientDetails(selectedClient.id);
        }
      } else {
        setError('Erro ao marcar pagamento como pago');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao marcar pagamento como pago');
    }
  };

  const handleUpdatePayment = async () => {
    if (!selectedPaymentId) return;
    
    try {
      const response = await axios.put(`${API_CONFIG.BASE_URL}/clients/payments/${selectedPaymentId}`, paymentForm);
      
      if (response.data.success) {
        setSuccess('Pagamento atualizado com sucesso!');
        setPaymentDialogOpen(false);
        setPaymentForm({});
        setSelectedPaymentId(null);
        if (selectedClient) {
          loadClientDetails(selectedClient.id);
        }
      } else {
        setError('Erro ao atualizar pagamento');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao atualizar pagamento');
    }
  };

  const handleDeletePayment = async (paymentId: string) => {
    try {
      const response = await axios.delete(`${API_CONFIG.BASE_URL}/clients/payments/${paymentId}`);
      
      if (response.data.success) {
        setSuccess('Pagamento deletado com sucesso!');
        if (selectedClient) {
          loadClientDetails(selectedClient.id);
        }
      } else {
        setError('Erro ao deletar pagamento');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao deletar pagamento');
    }
  };

  const handleUpdateContract = async () => {
    if (!selectedContractId) return;
    
    try {
      const response = await axios.put(`${API_CONFIG.BASE_URL}/clients/contracts/${selectedContractId}`, contractForm);
      
      if (response.data.success) {
        setSuccess('Contrato atualizado com sucesso!');
        setContractDialogOpen(false);
        setContractForm({});
        setSelectedContractId(null);
        if (selectedClient) {
          loadClientDetails(selectedClient.id);
        }
      } else {
        setError('Erro ao atualizar contrato');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao atualizar contrato');
    }
  };

  const handleDeleteContract = async (contractId: string) => {
    try {
      const response = await axios.delete(`${API_CONFIG.BASE_URL}/clients/contracts/${contractId}`);
      
      if (response.data.success) {
        setSuccess('Contrato deletado com sucesso!');
        if (selectedClient) {
          loadClientDetails(selectedClient.id);
        }
      } else {
        setError('Erro ao deletar contrato');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao deletar contrato');
    }
  };

  // Funções de manipulação de configurações CRM
  const handleSaveCrmConfig = async () => {
    if (!selectedClient) return;
    
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/clients/${selectedClient.id}/crm-config`, crmConfigForm);
      
      if (response.data.success) {
        setSuccess('Configuração CRM salva com sucesso!');
        setCrmConfigDialogOpen(false);
        setCrmConfigForm({});
        loadClientDetails(selectedClient.id);
      } else {
        setError('Erro ao salvar configuração CRM');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao salvar configuração CRM');
    }
  };

  // Funções de manipulação de prompts
  const handleCreatePrompt = async () => {
    if (!selectedClient) return;
    
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/clients/${selectedClient.id}/prompts`, promptForm);
      
      if (response.data.success) {
        setSuccess('Prompt criado com sucesso!');
        setPromptDialogOpen(false);
        setPromptForm({});
        loadClientDetails(selectedClient.id);
      } else {
        setError('Erro ao criar prompt');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao criar prompt');
    }
  };

  // Funções de interface
  const handleOpenClientDialog = (client?: Client) => {
    if (client) {
      setClientForm(client);
      setSelectedClient(client);
    } else {
      setClientForm({});
      setSelectedClient(null);
    }
    setClientDialogOpen(true);
  };

  const handleOpenContractDialog = (contract?: Contract) => {
    if (contract) {
      setContractForm(contract);
      setSelectedContractId(contract.id);
    } else {
      setContractForm({});
      setSelectedContractId(null);
    }
    setContractDialogOpen(true);
  };

  const handleOpenNewContractDialog = () => {
    setContractForm({});
    setSelectedContractId(null);
    setContractDialogOpen(true);
  };

  const handleOpenPaymentDialog = (payment?: Payment) => {
    if (payment) {
      setPaymentForm(payment);
      setSelectedPaymentId(payment.id);
    } else {
      setPaymentForm({});
      setSelectedPaymentId(null);
    }
    setPaymentDialogOpen(true);
  };

  const handleOpenNewPaymentDialog = () => {
    setPaymentForm({});
    setSelectedPaymentId(null);
    setPaymentDialogOpen(true);
  };

  const handleOpenCrmConfigDialog = (config?: CRMConfig) => {
    if (config) {
      setCrmConfigForm({
        frontend_url: config.frontend_url ?? '',
        backend_url: config.backend_url ?? '',
        api_key: config.api_key ?? '',
        webhook_url: config.webhook_url ?? '',
        whatsapp_instance_id: config.whatsapp_instance_id ?? '',
        telegram_bot_token: config.telegram_bot_token ?? '',
        custom_domain: config.custom_domain ?? '',
        ssl_enabled: config.ssl_enabled ?? false,
      });
    } else {
      setCrmConfigForm({
        frontend_url: '',
        backend_url: '',
        api_key: '',
        webhook_url: '',
        whatsapp_instance_id: '',
        telegram_bot_token: '',
        custom_domain: '',
        ssl_enabled: false,
      });
    }
    setCrmConfigDialogOpen(true);
  };

  const handleOpenPromptDialog = (prompt?: AIPrompt) => {
    if (prompt) {
      setPromptForm(prompt);
    } else {
      setPromptForm({});
    }
    setPromptDialogOpen(true);
  };

  const handleOpenPromptDialogClick = () => {
    handleOpenPromptDialog();
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, clientId: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedClientId(clientId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedClientId(null);
  };

  const handleClientClick = (client: Client) => {
    setSelectedClient(client);
    loadClientDetails(client.id);
  };

  // Funções de formatação
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return 'success';
      case 'inactive': return 'default';
      case 'suspended': return 'warning';
      case 'trial': return 'info';
      case 'paid': return 'success';
      case 'pending': return 'warning';
      case 'overdue': return 'error';
      default: return 'default';
    }
  };

  const getPlanColor = (plan: string) => {
    switch (plan) {
      case 'sem_api': return 'default';
      case 'com_api': return 'primary';
      default: return 'default';
    }
  };

  // Componente de abas
  const TabPanel = ({ children, value, index, ...other }: any) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`client-tabpanel-${index}`}
      aria-labelledby={`client-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 2, md: 3 }, overflowX: 'auto', maxWidth: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', p: { xs: 1.5, sm: 2, md: 3 }, overflowX: 'hidden' }}>
      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* Success Alert */}
      {success && (
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: isMobile ? 'center' : 'right' }}
          open={!!success}
          autoHideDuration={4000}
          onClose={() => setSuccess('')}
        >
          <Alert variant="filled" onClose={() => setSuccess('')} severity="success">
            {success}
          </Alert>
        </Snackbar>
      )}

      {/* Header */}
      <Box className="glass-blue-card rounded-xl p-4 mb-6" sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', md: 'center' },
        flexWrap: 'wrap',
        gap: 2,
        p: { xs: 2, md: 3 },
      }}>
        {/* Esquerda: Título e Descrição */}
        <Box sx={{ order: { xs: 1, md: 1 } }}>
          <Typography variant="h4" component="h1" sx={{ 
            fontWeight: 'bold',
            color: 'text.primary',
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2.125rem' },
            mb: 0.5
          }}>
            Gerenciamento de Clientes
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: { xs: '0.75rem', md: '0.875rem' } }}>
            Controle completo dos seus clientes, contratos, pagamentos e configurações
          </Typography>
        </Box>

        {/* Filtros e busca */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: { xs: 1, sm: 2 },
          flexWrap: 'wrap',
          flex: { md: 1 },
          justifyContent: { xs: 'stretch', md: 'center' },
          order: { xs: 3, md: 2 },
          width: { xs: '100%', md: 'auto' },
        }}>
          <TextField
            size="small"
            placeholder="Buscar clientes..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth={isMobile}
            sx={{
              minWidth: { xs: '100%', sm: 220 },
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(139, 92, 246, 0.08)',
                '& fieldset': {
                  borderColor: 'rgba(139, 92, 246, 0.2)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(139, 92, 246, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'rgba(139, 92, 246, 0.8)',
                },
              },
              '& .MuiInputBase-input': {
                color: '#000000',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#94a3b8' }} />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchQuery('')} size="small" sx={{ color: '#94a3b8' }}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 130 }, flex: { xs: '1 1 100%', sm: '0 0 auto' } }}>
            <InputLabel sx={{ color: 'text.secondary' }}>Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              label="Status"
              sx={{
                backgroundColor: 'rgba(139, 92, 246, 0.08)',
                color: '#000000',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.2)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.5)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.8)',
                },
                '& .MuiSvgIcon-root': {
                  color: '#64748b',
                },
              }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="active">Ativo</MenuItem>
              <MenuItem value="inactive">Inativo</MenuItem>
              <MenuItem value="suspended">Suspenso</MenuItem>
              <MenuItem value="trial">Trial</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 130 }, flex: { xs: '1 1 100%', sm: '0 0 auto' } }}>
            <InputLabel sx={{ color: 'text.secondary' }}>Plano</InputLabel>
            <Select
              value={planFilter}
              onChange={(e) => setPlanFilter(e.target.value)}
              label="Plano"
              sx={{
                backgroundColor: 'rgba(139, 92, 246, 0.08)',
                color: '#000000',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.2)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.5)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(139, 92, 246, 0.8)',
                },
                '& .MuiSvgIcon-root': {
                  color: '#64748b',
                },
              }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="sem_api">Sem API</MenuItem>
              <MenuItem value="com_api">Com API</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Direita: Ações */}
        <Box sx={{ display: 'flex', gap: 1, order: { xs: 2, md: 3 }, width: { xs: '100%', md: 'auto' }, justifyContent: { xs: 'flex-end', md: 'flex-end' } }}>
          <Tooltip title="Atualizar">
            <IconButton onClick={loadClients} size={isMobile ? 'medium' : 'small'} sx={{ color: 'primary.main' }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenClientDialog()}
            fullWidth={isMobile}
            sx={{ color: '#fff', '&:hover': { color: '#fff' }, flex: { xs: 1, md: '0 0 auto' } }}
          >
            Novo Cliente
          </Button>
        </Box>
      </Box>

      {/* Dashboard Stats */}
      {dashboardStats && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={2.4}>
            <Box className="glass-blue-card rounded-xl p-4 hover:shadow-violet-500/10 transition-all duration-300 hover:scale-105">
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <BusinessIcon sx={{ mr: 1, color: '#8b5cf6', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b' }}>Total Clientes</Typography>
              </Box>
              <Typography variant="h4" sx={{ color: '#000000', fontWeight: 'bold' }}>
                {dashboardStats.total_clients}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Box className="glass-blue-card rounded-xl p-4 hover:shadow-green-500/10 transition-all duration-300 hover:scale-105">
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <CheckCircleIcon sx={{ mr: 1, color: '#10b981', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b' }}>Ativos</Typography>
              </Box>
              <Typography variant="h4" sx={{ color: '#000000', fontWeight: 'bold' }}>
                {dashboardStats.active_clients}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Box className="glass-blue-card rounded-xl p-4 hover:shadow-violet-500/10 transition-all duration-300 hover:scale-105">
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <AttachMoneyIcon sx={{ mr: 1, color: '#8b5cf6', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b' }}>Receita Total</Typography>
              </Box>
              <Typography variant="h4" sx={{ color: '#000000', fontWeight: 'bold' }}>
                {formatCurrency(dashboardStats.total_revenue)}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Box className="glass-blue-card rounded-xl p-4 hover:shadow-orange-500/10 transition-all duration-300 hover:scale-105">
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <ScheduleIcon sx={{ mr: 1, color: '#f59e0b', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b' }}>Pendentes</Typography>
              </Box>
              <Typography variant="h4" sx={{ color: '#000000', fontWeight: 'bold' }}>
                {dashboardStats.pending_payments}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <Box className="glass-blue-card rounded-xl p-4 hover:shadow-red-500/10 transition-all duration-300 hover:scale-105">
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <WarningIcon sx={{ mr: 1, color: '#ef4444', fontSize: 24 }} />
                <Typography variant="h6" sx={{ color: '#64748b' }}>Em Atraso</Typography>
              </Box>
              <Typography variant="h4" sx={{ color: '#000000', fontWeight: 'bold' }}>
                {dashboardStats.overdue_payments}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}

      {/* Lista de Clientes */}
      <Box className="glass-blue-card rounded-xl p-4" sx={{ p: { xs: 2, md: 3 }, overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FormControlLabel
            control={
              <Switch 
                checked={dense} 
                onChange={(e) => setDense(e.target.checked)}
                sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: 'primary.main' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'primary.main' } }}
              />
            }
            label={<Typography variant="body2" color="text.secondary">Compacto</Typography>}
          />
        </Box>
        <TableContainer sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', mx: { xs: -2, md: 0 }, px: { xs: 0, md: 0 } }}>
          <Table stickyHeader size={dense || isMobile ? 'small' : 'medium'} sx={{ minWidth: isMobile ? 700 : undefined }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Cliente
                </TableCell>
                <TableCell sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Contato
                </TableCell>
                <TableCell sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Status
                </TableCell>
                <TableCell sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Plano
                </TableCell>
                <TableCell align="right" sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Contratos
                </TableCell>
                <TableCell align="right" sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Último Pagamento
                </TableCell>
                <TableCell sx={{ 
                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                  color: '#000000',
                  fontWeight: 'bold',
                  borderBottom: '1px solid rgba(139, 92, 246, 0.2)'
                }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client) => (
                <TableRow
                  key={client.id}
                  hover
                  onClick={() => handleClientClick(client)}
                  sx={{ 
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(139, 92, 246, 0.1)',
                    },
                    '& td': {
                      color: '#000000',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                    }
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        src={client.avatar_url}
                        sx={{ mr: 2, width: 40, height: 40 }}
                      >
                        {client.company_name?.charAt(0) || '?'}
                      </Avatar>
                      <Box>
                        <Tooltip title={client.company_name} arrow>
                          <Typography variant="subtitle2" fontWeight={600} noWrap maxWidth={220} sx={{ color: '#000000' }}>
                            {client.company_name}
                          </Typography>
                        </Tooltip>
                        <Typography variant="caption" sx={{ color: '#64748b' }}>
                          {client.cnpj || client.cpf || 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Tooltip title={client.contact_name} arrow>
                        <Typography variant="body2" noWrap maxWidth={200} sx={{ color: '#000000' }}>
                          {client.contact_name}
                        </Typography>
                      </Tooltip>
                      <Tooltip title={client.email} arrow>
                        <Typography variant="caption" sx={{ color: '#64748b' }} noWrap maxWidth={220}>
                          {client.email}
                        </Typography>
                      </Tooltip>
                      {client.phone && (
                        <Typography variant="caption" sx={{ color: '#64748b' }} display="block">
                          {client.phone}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={client.status}
                      size="small"
                      sx={{
                        backgroundColor: getStatusColor(client.status) === 'success' ? 'rgba(16, 185, 129, 0.18)' :
                                        getStatusColor(client.status) === 'error' ? 'rgba(239, 68, 68, 0.18)' :
                                        getStatusColor(client.status) === 'warning' ? 'rgba(245, 158, 11, 0.2)' :
                                        'rgba(139, 92, 246, 0.18)',
                        color: getStatusColor(client.status) === 'success' ? '#047857' :
                               getStatusColor(client.status) === 'error' ? '#b91c1c' :
                               getStatusColor(client.status) === 'warning' ? '#b45309' :
                               '#6d28d9',
                        fontWeight: 600,
                        border: `1px solid ${getStatusColor(client.status) === 'success' ? 'rgba(16, 185, 129, 0.4)' :
                                               getStatusColor(client.status) === 'error' ? 'rgba(239, 68, 68, 0.4)' :
                                               getStatusColor(client.status) === 'warning' ? 'rgba(245, 158, 11, 0.4)' :
                                               'rgba(139, 92, 246, 0.4)'}`,
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={client.plan_type}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(139, 92, 246, 0.15)',
                        color: '#6d28d9',
                        fontWeight: 600,
                        border: '1px solid rgba(139, 92, 246, 0.4)',
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" sx={{ color: '#000000' }}>
                      {client.client_contracts?.length || 0}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {client.client_payments && client.client_payments.length > 0 ? (
                      <Box>
                        <Typography variant="body2" fontWeight={600} sx={{ color: '#000000' }}>
                          {formatCurrency(client.client_payments[0].amount)}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#64748b' }}>
                          {formatDate(client.client_payments[0].due_date)}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography variant="body2" sx={{ color: '#64748b' }}>
                        —
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={(e) => handleMenuClick(e, client.id)}
                      size="small"
                      sx={{
                        color: '#8b5cf6',
                        '&:hover': {
                          backgroundColor: 'rgba(139, 92, 246, 0.1)',
                        },
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Paginação */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 3, px: { xs: 0 } }}>
        <Button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          startIcon={!isMobile && <ArrowBackIcon />}
          size={isMobile ? 'small' : 'medium'}
        >
          Anterior
        </Button>
        <Typography variant="body2" sx={{ mx: { xs: 1, sm: 2 }, alignSelf: 'center' }}>
          Página {currentPage} de {totalPages}
        </Typography>
        <Button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
          endIcon={!isMobile && <ArrowForwardIcon />}
          size={isMobile ? 'small' : 'medium'}
        >
          Próxima
        </Button>
      </Box>

      {/* Menu de Ações */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          const client = clients.find(c => c.id === selectedClientId);
          if (client) {
            handleOpenClientDialog(client);
          }
          handleMenuClose();
        }}>
          <EditIcon sx={{ mr: 1 }} />
          Editar
        </MenuItem>
        <MenuItem onClick={() => {
          if (selectedClientId) setClientIdToDelete(selectedClientId);
          setDeleteDialogOpen(true);
          handleMenuClose();
        }}>
          <DeleteIcon sx={{ mr: 1 }} />
          Deletar
        </MenuItem>
      </Menu>

      {/* Diálogo de Cliente */}
      <Dialog
        open={clientDialogOpen}
        onClose={() => setClientDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          {selectedClient ? 'Editar Cliente' : 'Novo Cliente'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome da Empresa"
                value={clientForm.company_name || ''}
                onChange={(e) => setClientForm({ ...clientForm, company_name: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome do Contato"
                value={clientForm.contact_name || ''}
                onChange={(e) => setClientForm({ ...clientForm, contact_name: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={clientForm.email || ''}
                onChange={(e) => setClientForm({ ...clientForm, email: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone"
                value={clientForm.phone || ''}
                onChange={(e) => setClientForm({ ...clientForm, phone: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="CNPJ"
                value={clientForm.cnpj || ''}
                onChange={(e) => setClientForm({ ...clientForm, cnpj: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="CPF"
                value={clientForm.cpf || ''}
                onChange={(e) => setClientForm({ ...clientForm, cpf: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: 'text.primary' }}>Status</InputLabel>
                <Select
                  value={clientForm.status || ''}
                  onChange={(e) => setClientForm({ ...clientForm, status: e.target.value as any })}
                  label="Status"
                  sx={{ color: '#111827' }}
                  MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { color: '#111827' } } } }}
                >
                  <MenuItem value="active">Ativo</MenuItem>
                  <MenuItem value="inactive">Inativo</MenuItem>
                  <MenuItem value="suspended">Suspenso</MenuItem>
                  <MenuItem value="trial">Trial</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: 'text.primary' }}>Plano</InputLabel>
                <Select
                  value={clientForm.plan_type || ''}
                  onChange={(e) => setClientForm({ ...clientForm, plan_type: e.target.value as any })}
                  label="Plano"
                  sx={{ color: '#111827' }}
                  MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { color: '#111827' } } } }}
                >
                  <MenuItem value="sem_api">Sem API</MenuItem>
                  <MenuItem value="com_api">Com API</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observações"
                multiline
                rows={3}
                value={clientForm.notes || ''}
                onChange={(e) => setClientForm({ ...clientForm, notes: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setClientDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={selectedClient ? handleUpdateClient : handleCreateClient}
            variant="contained"
            sx={styles.buttonPrimary}
            className="sophisticated-button"
          >
            {selectedClient ? 'Atualizar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Confirmação de Exclusão */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => { setDeleteDialogOpen(false); setClientIdToDelete(null); }}
        fullScreen={isMobile}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja deletar este cliente? Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteClient}
            color="error"
            variant="contained"
          >
            Deletar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Detalhes do Cliente Selecionado */}
      {selectedClient && (
        <Card className="glass-blue-card" sx={{ mt: 3, ...styles.card, overflow: 'hidden' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
            {isMobile && (
              <IconButton onClick={() => setSelectedClient(null)} size="small" sx={{ ml: 0.5 }} aria-label="Fechar detalhes">
                <ArrowBackIcon />
              </IconButton>
            )}
            <Tabs
              value={clientDetailTab}
              onChange={(e, newValue) => setClientDetailTab(newValue)}
              variant={isMobile ? 'scrollable' : 'standard'}
              scrollButtons={isMobile ? 'auto' : false}
              allowScrollButtonsMobile
              sx={{ flex: 1, minHeight: 48, ...styles.tabs, '& .MuiTab-root': { minHeight: 48, py: 1.5 } }}
            >
              <Tab icon={!isMobile ? <BusinessIcon /> : undefined} iconPosition="start" label="Informações" />
              <Tab icon={!isMobile ? <ViewKanbanIcon /> : undefined} iconPosition="start" label={`Tarefas (${clientTasks.length})`} />
              <Tab icon={!isMobile ? <DescriptionIcon /> : undefined} iconPosition="start" label="Contratos" />
              <Tab icon={!isMobile ? <PaymentIcon /> : undefined} iconPosition="start" label="Pagamentos" />
              <Tab icon={!isMobile ? <SettingsIcon /> : undefined} iconPosition="start" label="Config. CRM" />
              <Tab icon={!isMobile ? <PsychologyIcon /> : undefined} iconPosition="start" label="Prompts IA" />
              <Tab icon={!isMobile ? <AssessmentIcon /> : undefined} iconPosition="start" label="Métricas" />
            </Tabs>
          </Box>

          <TabPanel value={clientDetailTab} index={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Card sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Informações Básicas
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar
                      src={selectedClient.avatar_url}
                      sx={{ mr: 2, width: 60, height: 60 }}
                    >
                      {selectedClient.company_name?.charAt(0) || '?'}
                    </Avatar>
                    <Box>
                      <Typography variant="h6">
                        {selectedClient.company_name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedClient.contact_name}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  <List dense>
                    <ListItem>
                      <ListItemIcon>
                        <EmailIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary="Email"
                        secondary={selectedClient.email}
                      />
                    </ListItem>
                    {selectedClient.phone && (
                      <ListItem>
                        <ListItemIcon>
                          <PhoneIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Telefone"
                          secondary={selectedClient.phone}
                        />
                      </ListItem>
                    )}
                    {(selectedClient.cnpj || selectedClient.cpf) && (
                      <ListItem>
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Documento"
                          secondary={selectedClient.cnpj || selectedClient.cpf}
                        />
                      </ListItem>
                    )}
                  </List>
                </Card>
              </Grid>
              <Grid item xs={12} md={8}>
                <Card sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Status e Plano
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <Chip
                      label={selectedClient.status}
                      size="small"
                      sx={{
                        backgroundColor: getStatusColor(selectedClient.status) === 'success' ? 'rgba(16, 185, 129, 0.2)' :
                                        getStatusColor(selectedClient.status) === 'error' ? 'rgba(239, 68, 68, 0.2)' :
                                        getStatusColor(selectedClient.status) === 'warning' ? 'rgba(245, 158, 11, 0.25)' :
                                        'rgba(139, 92, 246, 0.2)',
                        color: getStatusColor(selectedClient.status) === 'success' ? '#047857' :
                               getStatusColor(selectedClient.status) === 'error' ? '#b91c1c' :
                               getStatusColor(selectedClient.status) === 'warning' ? '#b45309' :
                               '#6d28d9',
                        fontWeight: 600,
                      }}
                    />
                    <Chip
                      label={selectedClient.plan_type}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(139, 92, 246, 0.2)',
                        color: '#6d28d9',
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                  {selectedClient.notes && (
                    <Box>
                      <Typography variant="subtitle2" gutterBottom>
                        Observações
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedClient.notes}
                      </Typography>
                    </Box>
                  )}
                </Card>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={clientDetailTab} index={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Tarefas Atribuídas ({clientTasks.length})
              </Typography>
            </Box>
            {loadingTasks ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : clientTasks.length > 0 ? (
              <TableContainer component={Paper} sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table stickyHeader size={dense || isMobile ? 'small' : 'medium'} sx={{ minWidth: isMobile ? 600 : undefined }}>
                  <TableHead sx={styles.table.head}>
                    <TableRow>
                      <TableCell>Título</TableCell>
                      <TableCell>Board</TableCell>
                      <TableCell>Lista</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Prazo</TableCell>
                      <TableCell>Criado em</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {clientTasks.map((task: any) => (
                      <TableRow key={task.id} sx={styles.table.row}>
                        <TableCell>{task.title}</TableCell>
                        <TableCell>{task.board?.name || 'N/A'}</TableCell>
                        <TableCell>{task.list?.name || 'N/A'}</TableCell>
                        <TableCell>
                          <Chip
                            label={task.is_completed ? 'Concluído' : 'Em Andamento'}
                            color={task.is_completed ? 'success' : 'default'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {task.due_date ? formatDate(task.due_date) : 'N/A'}
                        </TableCell>
                        <TableCell>{formatDate(task.created_at)}</TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => {
                              if (task.board?.id) {
                                window.open(`/kanban/${task.board.id}`, '_blank');
                              }
                            }}
                            color="primary"
                            disabled={!task.board?.id}
                          >
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Nenhuma tarefa atribuída a este cliente
                </Typography>
              </Box>
            )}
          </TabPanel>

          <TabPanel value={clientDetailTab} index={2}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Contratos ({selectedClient.client_contracts?.length || 0})
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpenNewContractDialog}
                sx={styles.buttonPrimary}
                className="sophisticated-button"
              >
                Novo Contrato
              </Button>
            </Box>
            {selectedClient.client_contracts && selectedClient.client_contracts.length > 0 ? (
              <TableContainer component={Paper} sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table stickyHeader size={dense || isMobile ? 'small' : 'medium'} sx={{ minWidth: isMobile ? 560 : undefined }}>
                  <TableHead sx={styles.table.head}>
                    <TableRow>
                      <TableCell>Número</TableCell>
                      <TableCell>Valor Mensal</TableCell>
                      <TableCell>Dia Pagamento</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Início</TableCell>
                      <TableCell>Fim</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedClient.client_contracts.map((contract) => (
                      <TableRow key={contract.id} sx={styles.table.row}>
                        <TableCell>{contract.contract_number}</TableCell>
                        <TableCell align="right">{formatCurrency(contract.monthly_value)}</TableCell>
                        <TableCell>{contract.payment_day}</TableCell>
                        <TableCell>
                          <Chip
                            label={contract.status}
                            color={getStatusColor(contract.status) as any}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>{formatDate(contract.start_date)}</TableCell>
                        <TableCell>{contract.end_date ? formatDate(contract.end_date) : 'N/A'}</TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                              size="small"
                              onClick={() => handleOpenContractDialog(contract)}
                              color="primary"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteContract(contract.id)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Nenhum contrato encontrado
                </Typography>
              </Box>
            )}
          </TabPanel>

          <TabPanel value={clientDetailTab} index={3}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Pagamentos ({selectedClient.client_payments?.length || 0})
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpenNewPaymentDialog}
                sx={styles.buttonPrimary}
                className="sophisticated-button"
              >
                Novo Pagamento
              </Button>
            </Box>
            {selectedClient.client_payments && selectedClient.client_payments.length > 0 ? (
              <TableContainer component={Paper} sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table stickyHeader size={dense || isMobile ? 'small' : 'medium'} sx={{ minWidth: isMobile ? 520 : undefined }}>
                  <TableHead sx={styles.table.head}>
                    <TableRow>
                      <TableCell>Valor</TableCell>
                      <TableCell>Vencimento</TableCell>
                      <TableCell>Pagamento</TableCell>
                      <TableCell>Contrato</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedClient.client_payments.map((payment) => (
                      <TableRow key={payment.id} sx={styles.table.row}>
                        <TableCell align="right">{formatCurrency(payment.amount)}</TableCell>
                        <TableCell>{formatDate(payment.due_date)}</TableCell>
                        <TableCell>
                          {payment.paid_date ? formatDate(payment.paid_date) : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {payment.contract_id ? (
                            selectedClient.client_contracts?.find(c => c.id === payment.contract_id)?.contract_number || 'N/A'
                          ) : (
                            <Chip label="Sem contrato" size="small" color="default" />
                          )}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={payment.status}
                            color={getStatusColor(payment.status) as any}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {payment.status === 'pending' && (
                              <Button
                                size="small"
                                onClick={() => handleMarkPaymentAsPaid(payment.id)}
                                startIcon={<CheckIcon />}
                                color="success"
                              >
                                Marcar Pago
                              </Button>
                            )}
                            <IconButton
                              size="small"
                              onClick={() => handleOpenPaymentDialog(payment)}
                              color="primary"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeletePayment(payment.id)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Nenhum pagamento encontrado
                </Typography>
              </Box>
            )}
          </TabPanel>

          <TabPanel value={clientDetailTab} index={4}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Configurações CRM
              </Typography>
              <Button
                variant="contained"
                startIcon={<SettingsIcon />}
                onClick={() => handleOpenCrmConfigDialog(selectedClient.client_crm_configs)}
                className="sophisticated-button"
              >
                {selectedClient.client_crm_configs ? 'Editar' : 'Configurar'}
              </Button>
            </Box>
            {selectedClient.client_crm_configs ? (
              <Card sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="URL Frontend"
                      value={selectedClient.client_crm_configs.frontend_url || ''}
                      InputProps={{
                        readOnly: true,
                        endAdornment: selectedClient.client_crm_configs.frontend_url && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => window.open(selectedClient.client_crm_configs?.frontend_url, '_blank')}
                              size="small"
                            >
                              <OpenInNewIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="URL Backend"
                      value={selectedClient.client_crm_configs.backend_url || ''}
                      InputProps={{
                        readOnly: true,
                        endAdornment: selectedClient.client_crm_configs.backend_url && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => window.open(selectedClient.client_crm_configs?.backend_url, '_blank')}
                              size="small"
                            >
                              <OpenInNewIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="WhatsApp Instance ID"
                      value={selectedClient.client_crm_configs.whatsapp_instance_id || ''}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Domínio Customizado"
                      value={selectedClient.client_crm_configs.custom_domain || ''}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              </Card>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Nenhuma configuração CRM encontrada
                </Typography>
              </Box>
            )}
          </TabPanel>

          <TabPanel value={clientDetailTab} index={5}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                Prompts de IA ({selectedClient.client_ai_prompts?.length || 0})
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpenPromptDialogClick}
                className="sophisticated-button"
              >
                Novo Prompt
              </Button>
            </Box>
            {selectedClient.client_ai_prompts && selectedClient.client_ai_prompts.length > 0 ? (
              <Grid container spacing={2}>
                {selectedClient.client_ai_prompts.map((prompt) => (
                  <Grid item xs={12} md={6} key={prompt.id}>
                    <Card sx={{ p: 2 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h6">
                          {prompt.prompt_name}
                        </Typography>
                        <Chip
                          label={prompt.prompt_type}
                          color="primary"
                          size="small"
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Versão: {prompt.version}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 2 }}>
                        {prompt.prompt_content.substring(0, 100)}...
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Chip
                          label={prompt.is_active ? 'Ativo' : 'Inativo'}
                          color={prompt.is_active ? 'success' : 'default'}
                          size="small"
                        />
                        <Button
                          size="small"
                          onClick={() => handleOpenPromptDialog(prompt)}
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Nenhum prompt encontrado
                </Typography>
              </Box>
            )}
          </TabPanel>

          <TabPanel value={clientDetailTab} index={6}>
            <Typography variant="h6" gutterBottom>
              Métricas de Uso
            </Typography>
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                Métricas em desenvolvimento
              </Typography>
            </Box>
          </TabPanel>
        </Card>
      )}

      {/* Diálogo de Contrato */}
      <Dialog
        open={contractDialogOpen}
        onClose={() => setContractDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>{selectedContractId ? 'Editar Contrato' : 'Novo Contrato'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Número do Contrato"
                value={contractForm.contract_number || ''}
                onChange={(e) => setContractForm({ ...contractForm, contract_number: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Valor Mensal"
                type="number"
                value={contractForm.monthly_value || ''}
                onChange={(e) => setContractForm({ ...contractForm, monthly_value: Number(e.target.value) })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Data de Início"
                type="date"
                value={contractForm.start_date || ''}
                onChange={(e) => setContractForm({ ...contractForm, start_date: e.target.value })}
                InputLabelProps={{ shrink: true }}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Data de Fim"
                type="date"
                value={contractForm.end_date || ''}
                onChange={(e) => setContractForm({ ...contractForm, end_date: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Dia do Pagamento"
                type="number"
                inputProps={{ min: 1, max: 31 }}
                value={contractForm.payment_day || ''}
                onChange={(e) => setContractForm({ ...contractForm, payment_day: Number(e.target.value) })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Contrato</InputLabel>
                <Select
                  value={contractForm.contract_type || ''}
                  onChange={(e) => setContractForm({ ...contractForm, contract_type: e.target.value as any })}
                  label="Tipo de Contrato"
                >
                  <MenuItem value="monthly">Mensal</MenuItem>
                  <MenuItem value="quarterly">Trimestral</MenuItem>
                  <MenuItem value="yearly">Anual</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={contractForm.auto_renewal || false}
                    onChange={(e) => setContractForm({ ...contractForm, auto_renewal: e.target.checked })}
                  />
                }
                label="Renovação Automática"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Termos do Contrato"
                multiline
                rows={3}
                value={contractForm.contract_terms || ''}
                onChange={(e) => setContractForm({ ...contractForm, contract_terms: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContractDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={selectedContractId ? handleUpdateContract : handleCreateContract}
            variant="contained"
            sx={styles.buttonPrimary}
            className="sophisticated-button"
          >
            {selectedContractId ? 'Atualizar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Pagamento */}
      <Dialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>{selectedPaymentId ? 'Editar Pagamento' : 'Novo Pagamento'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Contrato (Opcional)</InputLabel>
                <Select
                  value={paymentForm.contract_id || ''}
                  onChange={(e) => setPaymentForm({ ...paymentForm, contract_id: e.target.value })}
                  label="Contrato (Opcional)"
                >
                  <MenuItem value="">
                    <em>Sem contrato específico</em>
                  </MenuItem>
                  {selectedClient?.client_contracts?.map((contract) => (
                    <MenuItem key={contract.id} value={contract.id}>
                      {contract.contract_number} - {formatCurrency(contract.monthly_value)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Valor"
                type="number"
                value={paymentForm.amount || ''}
                onChange={(e) => setPaymentForm({ ...paymentForm, amount: Number(e.target.value) })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Data de Vencimento"
                type="date"
                value={paymentForm.due_date || ''}
                onChange={(e) => setPaymentForm({ ...paymentForm, due_date: e.target.value })}
                InputLabelProps={{ shrink: true }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Método de Pagamento</InputLabel>
                <Select
                  value={paymentForm.payment_method || ''}
                  onChange={(e) => setPaymentForm({ ...paymentForm, payment_method: e.target.value })}
                  label="Método de Pagamento"
                >
                  <MenuItem value="pix">PIX</MenuItem>
                  <MenuItem value="credit_card">Cartão de Crédito</MenuItem>
                  <MenuItem value="debit_card">Cartão de Débito</MenuItem>
                  <MenuItem value="bank_transfer">Transferência Bancária</MenuItem>
                  <MenuItem value="boleto">Boleto</MenuItem>
                  <MenuItem value="cash">Dinheiro</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observações"
                multiline
                rows={2}
                value={paymentForm.notes || ''}
                onChange={(e) => setPaymentForm({ ...paymentForm, notes: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={selectedPaymentId ? handleUpdatePayment : handleCreatePayment}
            variant="contained"
            sx={styles.buttonPrimary}
            className="sophisticated-button"
          >
            {selectedPaymentId ? 'Atualizar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Configuração CRM */}
      <Dialog
        open={crmConfigDialogOpen}
        onClose={() => setCrmConfigDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        disableEnforceFocus
      >
        <DialogTitle>Configuração CRM</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                autoFocus
                label="URL Frontend"
                value={crmConfigForm.frontend_url ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, frontend_url: e.target.value }))}
                placeholder="https://cliente.nubomind.com"
                inputProps={{ autoComplete: 'off' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="URL Backend"
                value={crmConfigForm.backend_url ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, backend_url: e.target.value }))}
                placeholder="https://api.cliente.nubomind.com"
                inputProps={{ autoComplete: 'off' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="API Key"
                value={crmConfigForm.api_key ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, api_key: e.target.value }))}
                type="password"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Webhook URL"
                value={crmConfigForm.webhook_url ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, webhook_url: e.target.value }))}
                placeholder="https://webhook.cliente.nubomind.com"
                inputProps={{ autoComplete: 'off' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="WhatsApp Instance ID"
                value={crmConfigForm.whatsapp_instance_id ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, whatsapp_instance_id: e.target.value }))}
                inputProps={{ autoComplete: 'off' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telegram Bot Token"
                value={crmConfigForm.telegram_bot_token ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, telegram_bot_token: e.target.value }))}
                type="password"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Domínio Customizado"
                value={crmConfigForm.custom_domain ?? ''}
                onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, custom_domain: e.target.value }))}
                placeholder="cliente.nubomind.com"
                inputProps={{ autoComplete: 'off' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={crmConfigForm.ssl_enabled ?? false}
                    onChange={(e) => setCrmConfigForm((prev) => ({ ...prev, ssl_enabled: e.target.checked }))}
                  />
                }
                label="SSL Habilitado"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCrmConfigDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={handleSaveCrmConfig}
            variant="contained"
            sx={styles.buttonPrimary}
            className="sophisticated-button"
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Prompt */}
      <Dialog
        open={promptDialogOpen}
        onClose={() => setPromptDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>Novo Prompt de IA</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Prompt</InputLabel>
                <Select
                  value={promptForm.prompt_type || ''}
                  onChange={(e) => setPromptForm({ ...promptForm, prompt_type: e.target.value as any })}
                  label="Tipo de Prompt"
                  required
                >
                  <MenuItem value="whatsapp">WhatsApp</MenuItem>
                  <MenuItem value="telegram">Telegram</MenuItem>
                  <MenuItem value="instagram">Instagram</MenuItem>
                  <MenuItem value="webchat">WebChat</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                  <MenuItem value="general">Geral</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome do Prompt"
                value={promptForm.prompt_name || ''}
                onChange={(e) => setPromptForm({ ...promptForm, prompt_name: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Versão"
                value={promptForm.version || '1.0.0'}
                onChange={(e) => setPromptForm({ ...promptForm, version: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={promptForm.is_active || false}
                    onChange={(e) => setPromptForm({ ...promptForm, is_active: e.target.checked })}
                  />
                }
                label="Ativo"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Conteúdo do Prompt"
                multiline
                rows={6}
                value={promptForm.prompt_content || ''}
                onChange={(e) => setPromptForm({ ...promptForm, prompt_content: e.target.value })}
                placeholder="Digite o prompt de IA aqui..."
                required
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPromptDialogOpen(false)}>
            Cancelar
          </Button>
          <Button
            onClick={handleCreatePrompt}
            variant="contained"
            sx={styles.buttonPrimary}
            className="sophisticated-button"
          >
            Criar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ClientManagement;
